import { Injectable } from '@angular/core';

import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as fromRoot from '../../../core/store';
import * as schoolSearchActions from '../actions/reports-school-search.action';
import { ReportsSchoolSearchState } from '../';

@Injectable()
export class ReportsSchoolSearchEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<ReportsSchoolSearchState>,
  ) { }


  searchResults$ = createEffect(() => this.actions$.pipe(
    ofType(schoolSearchActions.ReportsSchoolSearchActionTypes.ExecuteReportSearch),
    switchMap((action: schoolSearchActions.ExecuteReportsSchoolSearch) => {
      console.log('School Report Search Effect');
      console.log(action.payload);

      return of(new fromRoot.Go({
        path: ['reports', 'schoolsearchresults'],
        query: action.payload
      }));
    })
  ));
}
